import {PosOrderSummary} from "@/data/entities/order";
import {CreditCardIcon, XMarkIcon} from "@heroicons/react/16/solid";
import {FormattedMessage} from "react-intl";
import React from "react";
import {Badge} from "peggirkit";
import BadgeIconIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeIconIndicator";


const PaymentTag = ({order}: { order: PosOrderSummary }) => {
    if (order.cancelledOn !== null) {
        return (
            <Badge
                color={"danger"}
                size={"xs"}
                indicator={<BadgeIconIndicator icon={XMarkIcon}/>}
            >
                <FormattedMessage id={"cancelled"}/>
            </Badge>
        );
    }

    if (order.paymentMethod === "ONLINE") {
        return (
            <Badge
                color={"success"}
                size={"xs"}
                indicator={<BadgeIconIndicator icon={CreditCardIcon}/>}
            >
                <FormattedMessage id={"paidOnline"}/>
            </Badge>
        );
    }

    return (
        <Badge
            color={"warning"}
            size={"xs"}
            indicator={<BadgeIconIndicator icon={CreditCardIcon}/>}
        >
            <FormattedMessage id={order.delivery ? "payOnDelivery" : "payOnTakeaway"}/>
        </Badge>
    );


};

export default PaymentTag;